import React from 'react';
import PlainFourOhFour from './plain/404';
import PlainFiveOhThree from './plain/503';
import PlainMaintenance from './plain/maintenance';
import SignFourOhFour from './sign/404';
import SignFiveOhThree from './sign/503';
import SignMaintenance from './sign/maintenance';
import BackgroundFourOhFour from './background/404';
import BackgroundFiveOhThree from './background/503';
import BackgroundMaintenance from './background/maintenance';

export default {
  plain: {
    FourOhFour: PlainFourOhFour,
    FiveOhThree: PlainFiveOhThree,
    Maintenance: PlainMaintenance,
  },
  sign: {
    FourOhFour: SignFourOhFour,
    FiveOhThree: SignFiveOhThree,
    Maintenance: SignMaintenance,
  },
  background: {
    FourOhFour: BackgroundFourOhFour,
    FiveOhThree: BackgroundFiveOhThree,
    Maintenance: BackgroundMaintenance,
  },
};
